import React from 'react'

const Tab = (props) => {
  const { activeTab, label, onClick } = props

  const handleOnClick = () => {
    onClick(label);
  }

  let className = 'dashboard-layout-navigation-item';

  if (activeTab === label) {
    className += ' dashboard-layout-navigation-item--active';
  }

  if (label !== '') {
    return (
      <li className={className} onClick={handleOnClick} >
        {label}
      </li>
    )
  } else {
    return <></>
  }
}

export default React.memo(Tab);
